import { get, writable } from 'svelte/store';
import { user_data } from 'src/stores/account/user';
import { normalizeEmail } from 'src/helpers/email_helpers';

export type EnergyMonitoringDataMode = 'real' | 'demo';

const STORAGE_KEY_PREFIX = 'energy_monitoring_data_mode';

const getAccountScope = (): string => {
	const user = get(user_data);
	const email = user?.email ? normalizeEmail(user.email) : '';
	return email || String(user?.id ?? 'anonymous');
};

const getStorageKey = (): string => `${STORAGE_KEY_PREFIX}_${getAccountScope()}`;

export const loadEnergyMonitoringDataMode = (): EnergyMonitoringDataMode => {
	if (typeof localStorage === 'undefined') return 'real';
	try {
		const raw = localStorage.getItem(getStorageKey());
		return raw === 'demo' ? 'demo' : 'real';
	} catch {
		return 'real';
	}
};

export const saveEnergyMonitoringDataMode = (mode: EnergyMonitoringDataMode) => {
	if (typeof localStorage === 'undefined') return;
	localStorage.setItem(getStorageKey(), mode);
};

export const energyMonitoringDataMode = writable<EnergyMonitoringDataMode>(
	loadEnergyMonitoringDataMode(),
);

export const setEnergyMonitoringDataMode = (mode: EnergyMonitoringDataMode) => {
	saveEnergyMonitoringDataMode(mode);
	energyMonitoringDataMode.set(mode);
};

export const isEnergyMonitoringDemoMode = (): boolean => get(energyMonitoringDataMode) === 'demo';
